module.exports = __webpack_public_path__ + "img/s-y.10ecb912.png";